export const STAR_RATING_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.StarRatingElement';
